document.addEventListener('DOMContentLoaded', function () {

  /* ---------------------------------------------------------
   * SHAPE + SIZE + MOUNT CONFIGURATOR
   * ------------------------------------------------------- */
  var shapeLabels = {
    rectangle: 'Rectangle',
    round: 'Round',
    oval: 'Oval',
    arch: 'Arch',
    pill: 'Pill / Stadium',
    radius: 'Radius Corner',
    corner: 'Corner',
    pebble: 'Pebble',
    halfmoon: 'Half Moon',
    luna: 'Luna',
    dune: 'Dune',
    stone: 'Stone',
    other: 'Design Your Own'
  };
  var mountLabels = { glued: 'Glued to Wall', hung: 'Wall Hangers' };
  var orientationLabels = { up: 'Up', down: 'Down', left: 'Left', right: 'Right' };
  var orientationAngles = { up: 0, down: 180, left: -90, right: 90 };

  // Natural-space outlines for the freeform shapes (Pebble, Half Moon, Luna,
  // Dune, Stone) and the Design Your Own placeholder (reuses the Pebble
  // path). Each has its own natural width/height, scaled non-uniformly to
  // fit whatever width/height the customer enters. Pebble, Luna, Dune and
  // Stone are the client's own traced SVGs, used verbatim (naturalW/H match
  // their source viewBox dimensions). Half Moon is a hand-drawn
  // approximation pending client artwork.
  var FREEFORM_SHAPES = {
    pebble: {
      path: 'M2.38008 38.0581C7.67472 48.3696 21.1177 57.2581 26.0232 59.4735C35.2338 63.6331 45.2434 59.6581 48.5405 56.0274C51.8377 52.3966 53.5265 49.8735 55.1349 47.0427C56.7433 44.212 59.4775 36.0889 60.1209 33.2581C60.7642 30.4274 61.1663 25.8735 61.2467 23.0427C61.3271 20.212 59.8796 15.2889 59.1558 13.0735C58.432 10.8581 55.4566 7.65812 54.3307 6.6735C53.2048 5.68889 48.9426 3.10427 47.4147 2.61196C45.8867 2.11966 43.3937 1.38119 39.2119 1.25812C35.0302 1.13504 31.6526 2.42735 28.275 3.71966C24.8974 5.01196 16.7751 9.93505 12.8345 13.0735C8.89401 16.212 1.81715 23.0427 1.41506 27.3504C1.01296 31.6581 1.34926 34.5429 2.38008 38.0581Z',
      naturalW: 63, naturalH: 63
    },
    halfmoon: {
      path: 'M70,10 A40,40 0 0 0 70,90 Z',
      naturalW: 80, naturalH: 100
    },
    luna: {
      path: 'M8.61823 35.0889C10.8994 36.3176 15.1434 37.4528 16.7348 37.386C20.5032 37.228 22.6764 35.7834 27.4509 36.5847C32.2254 37.386 32.9415 38.2942 35.3553 39.5229C37.7691 40.7516 38.9494 42.8617 42.1987 43.85C45.448 44.8383 47.1059 46.1738 50.0501 44.3308C52.9944 42.4877 59.2012 34.3144 59.9174 32.2042C60.6335 30.094 61.1773 26.7419 61.2436 25.4732C61.3099 24.2044 60.859 22.2278 59.9174 20.6118C58.9757 18.9958 57.3312 16.3782 55.8325 15.0026C54.3339 13.627 48.9228 13.1737 46.4427 10.9426C44.4533 9.15299 41.8474 4.70744 38.5383 2.98286C35.5145 1.40693 35.037 1.00628 32.2254 1.38023C29.4137 1.75418 26.1777 2.66234 24.5332 3.62392C22.8886 4.5855 20.7136 5.54708 18.3263 6.40182C15.9391 7.25655 10.0506 9.55366 8.14078 10.6755C6.23098 11.7973 4.05595 13.9876 3.048 15.9642C2.04005 17.9408 0.50161 22.3747 1.66871 26.2745C2.8358 30.1742 6.33709 33.8603 8.61823 35.0889Z',
      naturalW: 63, naturalH: 47
    },
    dune: {
      path: 'M2.97267 13.3131C1.5084 16.4836 1.25 18.026 1.25 19.2257C1.25 20.4253 1.7668 22.9103 2.62813 24.367C3.48947 25.8237 5.81507 28.223 9.77721 30.4509C13.7393 32.6788 18.046 35.8493 22.8695 36.1063C27.693 36.3634 30.0186 36.4491 36.8231 34.821C43.6276 33.1929 50.6044 30.7936 53.6191 29.5083C56.6338 28.223 56.0308 28.48 57.5813 27.2804C59.1317 26.0808 60.5959 23.7672 61.0266 21.882C61.4573 19.9969 61.285 14.7698 60.3375 12.8847C59.3901 10.9995 57.5813 9.45714 56.2031 8.51456C54.825 7.57199 47.4175 5.34408 42.1634 4.14444C36.9092 2.94479 29.5879 1.4024 26.6594 1.4024C23.7308 1.4024 21.0607 1.05964 18.8212 1.4024C16.5817 1.74515 13.5671 2.94479 11.3276 4.14444C9.08814 5.34408 4.43694 10.1426 2.97267 13.3131Z',
      naturalW: 63, naturalH: 38
    },
    stone: {
      path: 'M1.32604 35.8461C0.601406 45.1554 5.1907 54.1605 9.35728 56.5334C13.5239 58.9064 20.6493 60.7317 24.0913 61.036C27.5332 61.3402 39.5499 62.192 42.8107 55.925C46.0715 49.6579 46.8565 49.0495 47.2188 42.539C47.5811 36.0286 44.6826 19.9046 44.0184 16.4973C43.3541 13.09 41.2407 7.73558 38.7649 5.18008C36.2891 2.62459 31.2771 -0.174293 24.9367 2.07698C18.5962 4.32825 12.6785 9.07418 7.84764 14.7328C3.01681 20.3914 2.05067 26.5367 1.32604 35.8461Z',
      naturalW: 49, naturalH: 63
    }
  };

  /* ---------------------------------------------------------
   * PRICING ENGINE
   * Rectangle/square = sharp 90 degree corners. Everything else (round,
   * oval, arch, pill, radius corner, pebble, half moon, luna, dune, stone,
   * design-your-own) is priced as "any other shape". Orientation is
   * cosmetic/manufacturing-reference only, it doesn't change area,
   * perimeter or price.
   *
   * All rates read from data attributes on #shape-mirror-configurator
   * (set from section.settings in the Liquid template), so a merchant can
   * update pricing from the theme editor without touching this file —
   * matches the pattern used by the custom-glass calculator.
   * ------------------------------------------------------- */
  var configuratorRoot = document.getElementById('shape-mirror-configurator');
  function readRate(name, fallback) {
    if (!configuratorRoot) return fallback;
    var raw = configuratorRoot.dataset[name];
    var parsed = parseFloat(raw);
    return isNaN(parsed) ? fallback : parsed;
  }

  var RECT_GLUE_RATE_PER_SQM = readRate('rectGlueRate', 121);       // 6mm silver material only, $/m²
  var RECT_GLUE_EDGE_RATE = readRate('rectGlueEdgeRate', 4);        // flat polished edge, $/linear metre
  var RECT_GLUE_MIN_PRICE = readRate('rectGlueMin', 30);
  var RETAIL_MARGIN_DIVISOR = readRate('retailMarginDivisor', 0.6); // retail = cost / (1 - 40%)
  var HANGER_WASTE_FACTOR = readRate('hangerWasteFactor', 1.4);
  var HANGER_UNIT_RATE = readRate('hangerUnitRate', 5);

  var PRICE_RATES = {
    rectHanger: { mirror: readRate('rectHangerMirrorRate', 87.51), edge: readRate('rectHangerEdgeRate', 6), special: 0 },
    otherHanger: { mirror: readRate('otherHangerMirrorRate', 87.51), edge: readRate('otherHangerEdgeRate', 20), special: readRate('otherHangerSpecial', 46) },
    otherGlue: { mirror: readRate('otherGlueMirrorRate', 50), edge: readRate('otherGlueEdgeRate', 20), special: readRate('otherGlueSpecial', 46) }
  };

  function hangerHardwareCost(widthMM) { return (widthMM * HANGER_WASTE_FACTOR * HANGER_UNIT_RATE) / 1000; }

  function calcPrice(shape, mount, wMM, hMM) {
    var area = (wMM * hMM) / 1e6;          // m²
    var perimeter = (2 * (wMM + hMM)) / 1000; // linear metres
    var isRect = shape === 'rectangle';

    // Rectangle/square + glued: material (area x rate) plus flat polished
    // edging (perimeter x rate), floored at the minimum. Same method as the
    // cut-to-size mirror and custom glass calculators.
    if (isRect && mount === 'glued') {
      return Math.max((area * RECT_GLUE_RATE_PER_SQM) + (perimeter * RECT_GLUE_EDGE_RATE), RECT_GLUE_MIN_PRICE);
    }

    var rates = isRect ? PRICE_RATES.rectHanger : (mount === 'hung' ? PRICE_RATES.otherHanger : PRICE_RATES.otherGlue);
    var hanger = mount === 'hung' ? hangerHardwareCost(wMM) : 0;
    var cost = (rates.mirror * area) + (rates.edge * perimeter) + rates.special + hanger;
    return cost / RETAIL_MARGIN_DIVISOR;
  }

  var state = { shape: 'rectangle', mount: 'glued', orientation: 'up' };

  // Luna and Dune are naturally wide/short shapes (their reference art is
  // wider than it is tall), so they default to a landscape 900x600 size
  // instead of the standard 600x900 portrait default used by every other
  // shape. Selecting a shape resets Width/Height to its default.
  var SHAPE_DEFAULT_DIMS = {
    luna: { w: 900, h: 600 },
    dune: { w: 900, h: 600 }
  };
  var DEFAULT_DIMS = { w: 600, h: 900 };

  var shapeSelector = document.getElementById('shape-selector');
  var orientationSelector = document.getElementById('orientation-selector');
  var mountSelector = document.getElementById('mount-selector');
  var widthInput = document.getElementById('input-width');
  var heightInput = document.getElementById('input-height');
  var diameterInput = document.getElementById('input-diameter');

  var sizeStandardBox = document.getElementById('size-standard');
  var sizeRoundBox = document.getElementById('size-round');
  var sizeOtherNote = document.getElementById('size-other-note');

  var previewShapeGroup = document.getElementById('preview-shape-group');
  var previewDimLabel = document.getElementById('preview-dimension-label');
  var previewPrice = document.getElementById('preview-price');

  var specShape = document.getElementById('spec-shape');
  var specOrientation = document.getElementById('spec-orientation');
  var specSize = document.getElementById('spec-size');
  var specMount = document.getElementById('spec-mount');

  // Guard: if the configurator markup isn't present on this page (e.g. the
  // section was reused elsewhere without the configurator block), skip
  // wiring it up rather than throwing on null selectors.
  if (!shapeSelector || !orientationSelector || !mountSelector || !widthInput || !heightInput) {
    return bootFaqAndFloatingCta();
  }

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var STAGE_MAX = 190; // px, max shape footprint inside the 240x220 viewBox

  function clamp(val, min, max) { return Math.max(min, Math.min(max, val)); }

  function currentDimsMM() {
    if (state.shape === 'round') {
      var d = clamp(parseFloat(diameterInput.value) || 0, 50, 5000);
      return { w: d, h: d };
    }
    var w = clamp(parseFloat(widthInput.value) || 0, 50, 5000);
    var h = clamp(parseFloat(heightInput.value) || 0, 50, 5000);
    return { w: w, h: h };
  }

  function sizeLabel(dims) {
    if (state.shape === 'round') return '⌀ ' + dims.w + 'mm';
    return dims.w + 'mm × ' + dims.h + 'mm';
  }

  function buildShapeNode(shape, x, y, w, h) {
    var node;
    if (shape === 'round' || shape === 'oval') {
      node = document.createElementNS(SVG_NS, 'ellipse');
      node.setAttribute('cx', x + w / 2);
      node.setAttribute('cy', y + h / 2);
      node.setAttribute('rx', w / 2);
      node.setAttribute('ry', h / 2);
    } else if (shape === 'pill') {
      var r = Math.min(w, h) / 2;
      node = document.createElementNS(SVG_NS, 'rect');
      node.setAttribute('x', x); node.setAttribute('y', y);
      node.setAttribute('width', w); node.setAttribute('height', h);
      node.setAttribute('rx', r); node.setAttribute('ry', r);
    } else if (shape === 'radius') {
      var rr = clamp(Math.min(w, h) * 0.16, 6, 40);
      node = document.createElementNS(SVG_NS, 'rect');
      node.setAttribute('x', x); node.setAttribute('y', y);
      node.setAttribute('width', w); node.setAttribute('height', h);
      node.setAttribute('rx', rr); node.setAttribute('ry', rr);
    } else if (shape === 'corner') {
      // Quarter-circle/ellipse "corner" piece: sharp point at bottom-left,
      // straight full-height left edge, straight full-width bottom edge,
      // and a single convex arc from the top of the left edge to the end
      // of the bottom edge. Bezier-approximated (kappa = 0.5523) so it
      // scales correctly for non-square width/height, unlike an SVG arc
      // command which would need recomputed sweep flags per aspect ratio.
      var k = 0.5523;
      var d = [
        'M', x, y,
        'C', (x + w * k), y, (x + w), (y + h * (1 - k)), (x + w), (y + h),
        'L', x, (y + h),
        'Z'
      ].join(' ');
      node = document.createElementNS(SVG_NS, 'path');
      node.setAttribute('d', d);
    } else if (shape === 'arch') {
      var ar = Math.min(w / 2, h);
      var d = [
        'M', x, y + h,
        'L', x, y + ar,
        'A', ar, ar, 0, 0, 1, x + w, y + ar,
        'L', x + w, y + h,
        'Z'
      ].join(' ');
      node = document.createElementNS(SVG_NS, 'path');
      node.setAttribute('d', d);
    } else {
      // rectangle (default)
      node = document.createElementNS(SVG_NS, 'rect');
      node.setAttribute('x', x); node.setAttribute('y', y);
      node.setAttribute('width', w); node.setAttribute('height', h);
      node.setAttribute('rx', 3); node.setAttribute('ry', 3);
    }
    node.setAttribute('fill', 'url(#mirrorGradient)');
    node.setAttribute('stroke', '#B8B8B8');
    node.setAttribute('stroke-width', '1.5');
    return node;
  }

  // Freeform shapes (Pebble, Half Moon, Luna, Dune, Stone) and the Design
  // Your Own placeholder (reuses the Pebble outline) are drawn from their own
  // natural-space path and scaled non-uniformly to fit the entered
  // bounding box. "dashed" (true for Design Your Own) renders it as an
  // unconfirmed sketch rather than a committed shape.
  function buildFreeformNode(shapeData, x, y, w, h, dashed) {
    var g = document.createElementNS(SVG_NS, 'g');
    g.setAttribute('transform', 'translate(' + x + ',' + y + ') scale(' + (w / shapeData.naturalW) + ',' + (h / shapeData.naturalH) + ')');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', shapeData.path);
    path.setAttribute('vector-effect', 'non-scaling-stroke');
    if (dashed) {
      path.setAttribute('fill', '#fafafa');
      path.setAttribute('stroke', '#CCCCCC');
      path.setAttribute('stroke-width', '3');
      path.setAttribute('stroke-dasharray', '5 4');
    } else {
      path.setAttribute('fill', 'url(#mirrorGradient)');
      path.setAttribute('stroke', '#B8B8B8');
      path.setAttribute('stroke-width', '1.5');
    }
    g.appendChild(path);
    return g;
  }

  function updatePreview(dims) {
    previewShapeGroup.innerHTML = '';
    previewShapeGroup.removeAttribute('transform');

    var scale = Math.min(STAGE_MAX / dims.w, STAGE_MAX / dims.h);
    var w = dims.w * scale, h = dims.h * scale;
    var x = (240 - w) / 2, y = (220 - h) / 2;

    if (state.shape === 'other') {
      previewShapeGroup.appendChild(buildFreeformNode(FREEFORM_SHAPES.pebble, x, y, w, h, true));
    } else if (FREEFORM_SHAPES[state.shape]) {
      previewShapeGroup.appendChild(buildFreeformNode(FREEFORM_SHAPES[state.shape], x, y, w, h, false));
    } else {
      previewShapeGroup.appendChild(buildShapeNode(state.shape, x, y, w, h));
    }

    var angle = orientationAngles[state.orientation] || 0;
    if (angle) { previewShapeGroup.setAttribute('transform', 'rotate(' + angle + ' 120 110)'); }

    if (previewDimLabel) previewDimLabel.textContent = sizeLabel(dims);
  }

  function updateSpecSummary(dims, priceText) {
    var sizeText = sizeLabel(dims);

    if (specShape) specShape.textContent = shapeLabels[state.shape];
    if (specOrientation) specOrientation.textContent = orientationLabels[state.orientation];
    if (specSize) specSize.textContent = sizeText;
    if (specMount) specMount.textContent = mountLabels[state.mount];

    // These feed the native Shopify contact form (name="contact[...]") so
    // the configurator's selections are included in the quote email —
    // the previous version only displayed them, the form itself never
    // actually submitted anywhere.
    var quoteShape = document.getElementById('quote-shape');
    var quoteOrientation = document.getElementById('quote-orientation');
    var quoteSize = document.getElementById('quote-size');
    var quoteMount = document.getElementById('quote-mount');
    var quotePrice = document.getElementById('quote-price');
    if (quoteShape) quoteShape.value = shapeLabels[state.shape];
    if (quoteOrientation) quoteOrientation.value = orientationLabels[state.orientation];
    if (quoteSize) quoteSize.value = sizeText;
    if (quoteMount) quoteMount.value = mountLabels[state.mount];
    if (quotePrice) quotePrice.value = priceText;
  }

  function updateSizeInputsVisibility() {
    sizeStandardBox.classList.toggle('hidden', state.shape === 'round');
    sizeRoundBox.classList.toggle('hidden', state.shape !== 'round');
    if (sizeOtherNote) sizeOtherNote.classList.toggle('hidden', state.shape !== 'other');
  }

  function applyShapeDefaultDims(shape) {
    if (shape === 'round') return; // diameter input is symmetric, unaffected
    var d = SHAPE_DEFAULT_DIMS[shape] || DEFAULT_DIMS;
    widthInput.value = d.w;
    heightInput.value = d.h;
  }

  function refreshAll() {
    updateSizeInputsVisibility();
    var dims = currentDimsMM();
    updatePreview(dims);

    var price = calcPrice(state.shape, state.mount, dims.w, dims.h);
    var priceText = '$' + price.toFixed(2);
    if (previewPrice) previewPrice.textContent = priceText;

    updateSpecSummary(dims, priceText);
  }

  // Shape tile clicks
  shapeSelector.addEventListener('click', function (e) {
    var tile = e.target.closest('.shape-tile');
    if (!tile) return;
    shapeSelector.querySelectorAll('.shape-tile').forEach(function (t) { t.classList.remove('selected'); });
    tile.classList.add('selected');
    state.shape = tile.dataset.shape;
    applyShapeDefaultDims(state.shape);
    refreshAll();
  });

  // Mount card clicks
  mountSelector.addEventListener('click', function (e) {
    var card = e.target.closest('.mount-card');
    if (!card) return;
    mountSelector.querySelectorAll('.mount-card').forEach(function (c) { c.classList.remove('selected'); });
    card.classList.add('selected');
    state.mount = card.dataset.mount;
    refreshAll();
  });

  // Orientation card clicks (own class name, kept separate from .mount-card
  // so the two controls can't accidentally cross-select each other)
  orientationSelector.addEventListener('click', function (e) {
    var btn = e.target.closest('.orientation-card');
    if (!btn) return;
    orientationSelector.querySelectorAll('.orientation-card').forEach(function (c) { c.classList.remove('selected'); });
    btn.classList.add('selected');
    state.orientation = btn.dataset.orientation;
    refreshAll();
  });

  [widthInput, heightInput, diameterInput].forEach(function (el) {
    if (el) el.addEventListener('input', refreshAll);
  });

  var ctaBtn = document.getElementById('cta-get-quote');
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () {
      refreshAll();
      var target = document.getElementById('quote-form');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  refreshAll();

  // Belt-and-braces: re-sync the hidden quote-* fields immediately before
  // the native Shopify form submits, in case a value changed without
  // triggering the input listeners above.
  var quoteForm = document.getElementById('shape-mirror-quote-form');
  if (quoteForm) {
    quoteForm.addEventListener('submit', function () {
      refreshAll();
    });
  }

  bootFaqAndFloatingCta();

  /* ---------------------------------------------------------
   * FAQ ACCORDION + FLOATING CTA
   * Split into its own function so it still runs even if the
   * configurator markup is missing for any reason (see guard above).
   * ------------------------------------------------------- */
  function bootFaqAndFloatingCta() {
    var faqContainer = document.getElementById('faq-container');
    if (faqContainer) {
      faqContainer.addEventListener('click', function (e) {
        var questionButton = e.target.closest('.faq-question');
        if (!questionButton) return;
        var item = questionButton.parentElement;
        var answer = item.querySelector('.faq-answer');
        var arrow = questionButton.querySelector('.faq-arrow');
        var isOpening = !answer.style.maxHeight || answer.style.maxHeight === '0px';

        faqContainer.querySelectorAll('.faq-item').forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.querySelector('.faq-answer').style.maxHeight = '0px';
            otherItem.querySelector('.faq-arrow').classList.remove('rotate-180');
          }
        });

        if (isOpening) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
          arrow.classList.add('rotate-180');
        } else {
          answer.style.maxHeight = '0px';
          arrow.classList.remove('rotate-180');
        }
      });
    }

    // Floating CTA — fades in once the visitor scrolls past the hero,
    // hides again near the quote form to avoid overlapping it. Matches the
    // behaviour already used on the custom-glass landing page.
    var floatBtn = document.getElementById('floating-cta');
    if (!floatBtn) return;
    var root = document.querySelector('.shopify-section--custom-shape-mirror');
    var heroH = (root && root.querySelector('main section:first-child') && root.querySelector('main section:first-child').offsetHeight) || 500;
    window.addEventListener('scroll', function () {
      if (window.scrollY > heroH) { floatBtn.classList.add('visible'); }
      else { floatBtn.classList.remove('visible'); }
      var form = document.getElementById('quote-form');
      if (form) {
        var formTop = form.getBoundingClientRect().top;
        if (formTop < window.innerHeight) { floatBtn.classList.remove('visible'); }
      }
    });
  }

});
